"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var brandColors = {
  green: {
    goGetta: '#05706d',
    keenGreen: '#0c8688',
    gameOn: '#249294',
    giveAShit: '#3d9ea0',
    deadset: '#8ac4c6',
    getItDone: '#ebf5f5'
  },
  purple: {
    sharp: '#3b307b',
    smartyPants: '#4a3c9a',
    nimble: '#6e62ae',
    clever: '#928ac2',
    insightful: '#b6b1d6',
    thoughtful: '#ecebf4'
  },
  yellow: {
    courageous: '#ffab00',
    brave: '#ffc44c',
    fearless: '#f9cb40',
    fiery: '#fad566',
    daring: '#fbdb79',
    dynamic: '#fff8db'
  },
  success: {
    competitive: '#05AA50',
    success: '#37BB73',
    optimistic: '#69CC96',
    confidence: '#E6F6ED'
  },
  information: {
    practical: '#0091ea',
    constructive: '#14b6ff',
    brilliant: '#69d1ff',
    useful: '#f3fbff'
  },
  highAttention: {
    firedUp: '#d54738',
    mission: '#e27e74',
    burningUp: '#eaa39b',
    crankin: '#faeceb'
  }
};
var greyScaleColors = {
  white: '#fff',
  tin: '#f9f9f9',
  ash: '#f3f3f3',
  cloud: '#eee',
  nickel: '#ddd',
  aluminium: '#ccc',
  silver: '#a7a9ac',
  spaceGrey: '#808285',
  gunMetal: '#58595b',
  charcoal: '#263133',
  black: '#000'
};
var primaryColors = {
  primary: brandColors.green.giveAShit,
  primaryDark: brandColors.green.gameOn,
  primaryDarker: brandColors.green.keenGreen,
  primaryDarkest: brandColors.green.goGetta,
  primaryLight: brandColors.green.deadset,
  primaryLighter: brandColors.green.getItDone
};
var secondaryColors = {
  secondary: brandColors.purple.smartyPants,
  secondaryDark: brandColors.purple.sharp,
  secondaryLight: brandColors.purple.nimble,
  secondaryLighten: brandColors.purple.clever,
  secondaryLighter: brandColors.purple.insightful,
  secondaryLightest: brandColors.purple.thoughtful
};
var tertiaryColors = {
  tertiary: brandColors.yellow.fearless,
  tertiaryDark: brandColors.yellow.brave,
  tertiaryDarker: brandColors.yellow.courageous,
  tertiaryLight: brandColors.yellow.fiery,
  tertiaryLighter: brandColors.yellow.daring,
  tertiaryLightest: brandColors.yellow.dynamic
};
var successColors = {
  success: brandColors.success.success,
  successDark: brandColors.success.competitive,
  successLight: brandColors.success.optimistic,
  successLighter: brandColors.success.confidence
};
var infoColors = {
  info: brandColors.information.constructive,
  infoDark: brandColors.information.practical,
  infoLight: brandColors.information.brilliant,
  infoLighter: brandColors.information.useful
};
var warningColors = {
  warning: brandColors.yellow.brave,
  warningDark: brandColors.yellow.courageous,
  warningLight: brandColors.yellow.fiery,
  warningLighter: brandColors.yellow.dynamic
};
var dangerColors = {
  danger: brandColors.highAttention.mission,
  dangerDark: brandColors.highAttention.firedUp,
  dangerLight: brandColors.highAttention.burningUp,
  dangerLighter: brandColors.highAttention.crankin
};
var linkColors = {
  link: infoColors.infoDark,
  linkHover: infoColors.infoDark
};
var loadingColors = {
  loadingPrimary: greyScaleColors.aluminium,
  loadingSecondary: '#e7e7e7',
  loadingTertiary: '#f2f2f2'
};
var externalColors = {
  facebook: '#3b5998',
  twitter: '#00a0d1',
  googleplus: '#d34836'
};
var bodyColors = {
  bodyBackground: greyScaleColors.white
};
var errorColors = {
  error: dangerColors.dangerDark
};
var padding = {
  large: '16px 32px',
  small: '5px 14px'
};
var color = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, primaryColors), secondaryColors), tertiaryColors), successColors), infoColors), warningColors), dangerColors), greyScaleColors), linkColors), loadingColors), externalColors), bodyColors), errorColors), padding);
var _default = exports.default = color;